import { useState } from "react";
import { FormDropdownProps } from "./FormDropdown.types";
import useClickOutside from "../../hooks/useClickOutside";
import DownIcon from "../../media/DownIcon";
import "./FormDropdown.css"

const FormDropdown = (props: FormDropdownProps) => {

  const { className, dropdown, label } = props
  const [showDropdowns, setShowDropdowns] = useState<boolean>(false)
  const [{ contextRef }] = useClickOutside({onClickOutside: () => setShowDropdowns(false)})

  return (
    <div className={`form-dropdown-container ${className}`}>
      <div className="form-dropdown">
        <p className="form-dropdown-label">{label}</p>
        <div className="form-dropdown-options-container" onClick={() => setShowDropdowns(!showDropdowns)} ref={contextRef}>
          <div className="form-dropdown-options-flex-container">
            <p>{dropdown.values[dropdown.selected]}</p>
            <div className={`form-dropdown-icon ${showDropdowns ? "form-dropdown-icon-rotate": ""}`}>
              <DownIcon />
            </div>
          </div>

          {showDropdowns && (
            <div className="form-dropdown-options">
              {dropdown.values.map((value, key) =>(
                <p
                  className="form-dropdown-option"
                  key={key}
                  onClick={() => dropdown.onChange(key)}
                >
                  {value}
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )

}

export default FormDropdown